module.exports = __webpack_public_path__ + "img/61.d30cec5d.jpg";